import 'scrolltofixed'

$('input[type=radio][name=ship_same_helper]').change(function () {
    if (this.value == 0) {
        $("#shipping-info").slideDown();
    } else if (this.value == 1) {
        $("#shipping-info").slideUp();
    }
});

// console.log($('footer').offset().top);

$('.fixed-element').scrollToFixed({
    marginTop: 110,
    minWidth: 975,
    limit: function () {
        var limit = $('footer').offset().top - $(this).outerHeight() - 100;
        return limit;
    },
    zIndex: 'auto',
});